<template>
  <div>
    <loading :active.sync="isLoading" :enforce-focus="false" loader="dots" />

    <Navbar />

    <div class="step-page">
      <section class="section-04">
        <div class="title">
          <span>職缺列表</span>
        </div>
        <div class="job-list">
          <div class="row" style="margin-bottom: 15px">
            <div class="col-md-3">
              <div class="from-group">
                <input
                  type="text"
                  class="form-control"
                  placeholder="請輸入關鍵字"
                  v-model.trim="searchCondition.ManpowerDemandName"
                  @keydown.stop.prevent.enter="searchCondition.ManpowerDemandNo = null, getJobOpening()"
                />
              </div>
            </div>
            <div class="col-md-3">
              <div class="from-group">
                <el-select
                  class="w-100"
                  :filterable="true"
                  clearable
                  placeholder="地點不拘"
                  v-model="searchCondition.Workplace"
                >
                  <el-option
                    v-for="workplace in workplaceOptions"
                    :key="workplace.Guid"
                    :label="workplace.WorkPlaceName"
                    :value="workplace.WorkPlaceName"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="col-md-3">
              <div class="from-group">
                <button class="btn btn-primary btn-sm" @click="searchCondition.ManpowerDemandNo = null, getJobOpening()">
                  <eva-icon name="search-outline" fill="#fff"></eva-icon>
                  查詢
                </button>
              </div>
            </div>
          </div>
          <div v-for="job in jobOpeningList" :key="job.No" class="job">
            <div class="info">
              <div class="name" @click="openJobDescriptionModal(job)">
                {{ job.ManpowerDemandName }}
                <eva-icon
                  name="question-mark-circle"
                  fill="red"
                ></eva-icon>
              </div>
              <div class="tag">
                <span v-for="place in job.WorkPlace" :key="place">{{
                  place
                }}</span>
                <span v-if="job.WorkExperienceWhatever">工作經驗不拘</span>
                <span v-else>{{ job.WorkExperience }} 年</span>
                <span v-if="job.EducationDemandWhatever">學歷不拘</span>
                <span
                  v-else
                  v-for="(education, index) in job.EducationDemand"
                  :key="index"
                >
                  {{ education }}
                </span>
              </div>
              <div class="desc">
                <pre style="font-size: 14px">{{ job.WorkContent }}</pre>
              </div>
            </div>
            <div class="edit">
              <button type="btn" class="btn" @click="getDemandInfo(job)">
                我要應徵
              </button>
            </div>
          </div>
        </div>
        <el-pagination
          v-if="totalData > 0"
          class="mb-3"
          background
          layout="prev, pager, next"
          :page-size="10"
          :total="totalData"
          style="text-align: center"
          @current-change="changePage"
        >
        </el-pagination>
        <p v-else class="mt-4 text-center" style="color: #fff">尚無資料</p>
      </section>

      <div
        class="modal fade"
        id="applyModal"
        tabindex="-1"
        aria-labelledby="jobModal"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <span class="modal-title">確認應徵</span>
            </div>
            <div class="modal-body">
              <p>應徵職務：{{ PositionName }}</p>
              <span>填寫履歷：</span>
              <a
                :href="ResumeType === 'IDL' ? `${url}/#/candidate/idl` : `${url}/#/candidate/dl`"
                target="_blank"
              >
                {{ ResumeType === "IDL" ? "IDL 履歷" : "DL 履歷" }}(確認應徵前，請完成履歷填寫)
              </a>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-secondary"
                data-dismiss="modal"
              >
                取消
              </button>
              <button type="submit" class="btn btn-primary" @click="apply">
                確認
              </button>
            </div>
          </div>
        </div>
      </div>

      <div
        class="modal fade"
        id="jobModal"
        tabindex="-1"
        aria-labelledby="jobModal"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <span class="modal-title">
                {{ job.ManpowerDemandName }}-職務說明
              </span>
            </div>
            <div class="modal-body">
              <span v-if="job.PositionInstruction === null">尚無說明</span>
              <pre v-else>{{ job.PositionInstruction }}</pre>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* global $ */
import { mapActions } from "vuex";
import moment from "moment";
import Navbar from "@/components/candidate/NavBar";

export default {
  name: "JobOpening",

  components: {
    Navbar,
  },
  data() {
    return {
      url: window.location.origin,

      // 工作地點
      workplaceOptions: [],
      // 職缺列表
      jobOpeningList: [],

      // 職務說明
      job: {},

      searchCondition: {}, // 查詢條件
      totalData: 0, // 總筆數
      currentPage: 1, // 當前頁數
      year: null, // 年
      date: null, // 日期

      // 履歷種類
      ResumeType: null,
      // 需求單單號
      manpowerDemandNo: null,
      // 職務名稱
      PositionName: null
    };
  },

  methods: {
    // 取得 職缺列表
    getJobOpening() {
      this.updateLoading(true);
      this.$api.jobOpening
        .getJobOpeningPaging({
          ...this.searchCondition,
          Page: this.currentPage,
          PerPage: 10,
        })
        .then((response) => {
          if (response.status === 200) {
            this.jobOpeningList = response.data.Datas;
            this.totalData = response.data.Quantity;
            window.scrollTo({
              top: 0,
              behavior: "smooth",
            });
          }
          this.updateLoading(false);
        });
    },

    // 取得 需求單資訊
    getDemandInfo(demand) {
      this.manpowerDemandNo = demand.No;
      this.$api.manpowerDemand
        .getManpowerDemandInfo({
          ManpowerDemandNo: this.manpowerDemandNo,
        })
        .then((response) => {
          if (response.status === 200) {
            this.ResumeType = response.data[0].ResumeType;
            this.PositionName = response.data[0].PositionName;
            localStorage.setItem("RESUME_TYPE", this.ResumeType);
            $("#applyModal").modal("show");
          }
        });
    },

    // 投遞履歷
    apply() {
      this.$api.resume
        .submitResume({
          UserId: this.$cookies.get("candidateId"),
          ManpowerDemandNo: this.manpowerDemandNo,
        })
        .then((response) => {
          if (response.status === 200) {
            $("#applyModal").modal("hide");
            this.$notify({
              title: "成功",
              message: "應徵成功",
              type: "success",
              duration: 2500,
            });
          }
        });
    },

    // 職務說明
    openJobDescriptionModal(item) {
      this.job = { ...item };
      $("#jobModal").modal("show");
    },

    // 登出
    logout() {
      this.$api.logout
        .logout({
          token: this.$cookies.get("AUTH_TOKEN"),
        })
        .then((response) => {
          if (response.status === 200) {
            this.$cookies
              .keys()
              .forEach((cookie) => this.$cookies.remove(cookie));
            this.$router.push({ path: "/signIn" });
          }
        });
    },

    // 換頁
    changePage(val) {
      this.currentPage = val;
      this.getJobOpening();
    },

    async getData() {
      await this.getJobOpening();
      // 取得 工作地點選項
      const workplace = await this.$api.workplace.getWorkplacePaging({
        isPaging: false,
      });
      this.workplaceOptions = workplace.data.Datas;
    },

    // loading
    ...mapActions(["updateLoading"]),
  },

  computed: {
    isLoading() {
      return this.$store.state.isLoading;
    },
  },

  filters: {
    year: function (date) {
      return moment(date).format("YYYY");
    },
    date: function (date) {
      return moment(date).format("MM/DD");
    },
  },

  created() {
    this.getData();
  },

  destroyed() {
    $(".modal").modal("hide");
    $("body").removeClass("modal-open");
    $(".modal-backdrop").remove();
  },
};
</script>

<style lang="scss" scoped>
.section-04 {
  .title {
    text-align: center;
    span {
      font-weight: bold;
      font-size: 2em;
      border-bottom: 5px solid #abc7ec;
      display: inline-block;
      color: #fff;
      margin-bottom: 40px;
      text-shadow: 2px 2px 5px rgba(0, 0, 0, 0.3);
    }
  }
  .job-list {
    max-width: 960px;
    margin: 0 auto;
    @media only screen and (max-width: 767px) {
      padding: 0 20px;
    }

    .job {
      display: flex;
      border-radius: 5px;
      box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.2);
      background-color: rgba(#fff, 0.9);
      margin-bottom: 10px;
      padding: 15px 5px;
      color: #383838;
      text-decoration: none;
      align-items: center;
      @media only screen and (max-width: 767px) {
        display: block;
        padding: 20px;
        br {
          display: none;
        }
      }
      .date {
        font-weight: bold;
        padding: 15px;
        text-align: center;
        margin-right: 20px;
        color: #383838;
        border-right: 1px solid #bdbdbd;

        @media only screen and (max-width: 767px) {
          border-right: none;
          br {
            display: none;
          }
        }
        .year {
          font-size: 1.3em;
        }
      }
      .info {
        width: 800px;
        @media only screen and (max-width: 767px) {
          max-width: 300px;
        }
        .name {
          font-weight: bold;
          display: inline-block;
          margin-right: 5px;
          @media only screen and (max-width: 767px) {
            display: block;
            text-align: center;
            margin-bottom: 20px;
          }
        }
        .tag {
          display: inline-block;
          span {
            background-color: #f1f1f1;
            padding: 3px 10px;
            border-radius: 25px;
            margin-right: 8px;
            font-size: 0.9em;
          }
        }
        .money {
          display: inline-block;
          background-color: #f1f1f1;
          color: #c7ddfe;
          padding: 3px 10px;
          border-radius: 25px;
        }
        .desc {
          margin-top: 10px;
          font-size: 0.9em;
          line-height: 175%;
          letter-spacing: 1px;
        }
      }

      .edit {
        margin-left: 10px;
        margin-right: 10px;
        button {
          background-color: #2f75d1;
          color: #ffffff;
          display: inline-block;
          padding: 7px;
          cursor: pointer;
          text-align: center;
          border: none;
          font-weight: bold;
          border-radius: 12px;
          width: 60px;
          height: 60px;
          text-decoration: none;
          box-shadow: 0 6px #5890da;
          &:hover {
            background-color: darken(#5890da, 10%);
          }
          &:active {
            background-color: #2f75d1;
            box-shadow: 0 3px #205192;
            transform: translateY(4px);
          }
          @media only screen and (max-width: 767px) {
            width: 100%;
            height: auto;
          }
        }
      }
    }

    pre {
      white-space: unset;
    }
  }
}
</style>
